export default class CookieConsent {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        this.acceptBtn = this.element.querySelector("#cookie-consent--accept");
        this.declineBtn = this.element.querySelector(
            "#cookie-consent--decline"
        );
        this.init();
        this.bindEvents();
    }
    init() {
        if (!this.getCookie("bbg_consent")) {
            Livewire.on(
                "checkCurrentUserForCookieConsent",

                this.checkCookie()
            );
        }
        return;
    }
    bindEvents() {
        if (this.acceptBtn) {
            this.acceptBtn.addEventListener("click", e => this.acceptCookies());
            this.declineBtn.addEventListener("click", e => this.redirectUser());
        }
    }

    redirectUser() {
        window.location.href = "https://www.google.com/";
    }

    checkCookie() {
        let cookieExpirationElement = this.element.querySelector(
            ".cookie-consent--expiration-check"
        );
        if (cookieExpirationElement) {
            let cookieExpirationDate = parseInt(
                cookieExpirationElement.dataset.expiration
            );
            this.element.removeChild(cookieExpirationElement);
            if (cookieExpirationDate > 0) {
                this.setCookie("bbg_consent", "1", cookieExpirationDate);
                return;
            }
            this.showCookieBar();
        }
    }
    showCookieBar() {
        this.element.classList.add("cookie-consent--visible");
    }
    hideCookieBar() {
        this.element.classList.remove("cookie-consent--visible");
    }
    acceptCookies() {
        this.hideCookieBar();
        this.setCookie("bbg_consent", "1", 365);
    }
    setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    eraseCookie(name) {
        document.cookie =
            name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
}
